import React, { useEffect } from "react";
import { Link } from 'react-router-dom';
import { Footer } from "../components/Footer.js";
import Head_CateHead from "../components/Head_CateHead.js";
import order_thanks from "./../assets/img/order_thanks.jpg";
import { Widgets } from "@mui/icons-material";

const OrderThanks = () => {
    // Fire the GTM purchase event once. The details are written by checkout and
    // removed here, so a refresh or revisit of /thanks_order can't double count.
    useEffect(() => {
        let purchase = null;
        try {
            purchase = JSON.parse(sessionStorage.getItem("purchaseEvent"));
            sessionStorage.removeItem("purchaseEvent");
        } catch (e) {
            return;
        }
        if (!purchase || !purchase.transaction_id) return;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'purchase',
            ecommerce: {
                transaction_id: purchase.transaction_id,
                value: purchase.value, // order total ex GST
                currency: 'AUD'
            }
        });
    }, []);

    const orderThanksStyles = {
        textAlign: 'center',
        margin: '50px auto',
        padding: '20px',
        maxWidth: '600px',
        backgroundColor: '#fff',
    };
    const headingStyles = {
        fontSize: '2em',
        marginBottom: '20px',
        color: '#333',
    };
    const paragraphStyles = {
        fontSize: '1.2em',
        color: '#666',
    };
    const footerStyles = {
        textAlign: 'center',
        padding: '20px',
        backgroundColor: '#333',
        color: '#fff',
    };
    return (
        <div>
            <Head_CateHead />
            <div style={orderThanksStyles}>
                <h1 style={headingStyles}>Thank You for Your Order!</h1>
                <p style={paragraphStyles}>Your order has been successfully placed. We appreciate your business.</p>
                <img src={order_thanks} style={{width:'60%'}} />
            </div>
            <Footer style={footerStyles} />
        </div>
    );
};

export default OrderThanks;
